import api from '../../../../api/core';
import { API_VERSION } from '../../../../api/react-query/constants';
import useGenericMutation from '../../../../api/react-query/use-generic-mutation';
import { useTranslate } from '../../../../hooks';

export function useDeleteV2({
  url,
  params = {},
  customInvalidateQueriesUrl,
  msg,
  apiVersion = API_VERSION,
}) {
  const { translate } = useTranslate();

  params['locale'] = localStorage.getItem('applang');

  return useGenericMutation({
    func: (data) => api.delete(`${apiVersion}/${url}`,{data}, { params }),
    url,
    params,
    customInvalidateQueriesUrl,
    msg: msg ?? translate('deleted-successfully'),
  });
}
